<template>
  <div id="app">
    <album-list/>
  </div>
</template>

<script>
import AlbumList from './components/AlbumList.vue';

export default {
  name: 'app',
  components: {
    AlbumList
  }
};
</script>
